// Logistics → Calendar mode panel (turbo_logistics.md §6.2).
import { useCallback, useState } from "react";
import { LogisticsCalendarDayRoutes } from "./LogisticsCalendarDayRoutes";
import { LogisticsCalendarWeekGrid } from "./LogisticsCalendarWeekGrid";
import { LogisticsGateBanner } from "./LogisticsGateBanner";
import { LogisticsRoutesDetailCard } from "./LogisticsRoutesDetailCard";
import { useLogisticsAnchorLayerGate } from "./useLogisticsAnchorLayerGate";
import { useLogisticsCalendarPanel } from "./useLogisticsCalendarPanel";
import { ghostBtnClass } from "./logisticsRoutesShared";

export function LogisticsCalendarPanel() {
  const gate = useLogisticsAnchorLayerGate();
  const [navTick, setNavTick] = useState(0);
  const c = useLogisticsCalendarPanel(navTick);

  const handleRefresh = useCallback(() => {
    gate.refresh();
    setNavTick((s) => s + 1);
    c.refreshAll();
  }, [gate, c]);

  const labelLookup = { units: c.units, carriers: c.carriers };

  return (
    <div className="w-full text-left space-y-4">
      <div className="flex flex-wrap items-center gap-3 justify-between">
        <h2 className="text-lg font-bold text-gray-900 dark:text-zinc-100">Delivery calendar</h2>
        <div className="flex flex-wrap items-center gap-2">
          <button
            type="button"
            className={ghostBtnClass}
            onClick={() => c.shiftWeek(-1)}
            disabled={!gate.enabled || gate.loading || c.listBusy}
          >
            ← Prev week
          </button>
          <button
            type="button"
            className={ghostBtnClass}
            onClick={c.goToToday}
            disabled={!gate.enabled || gate.loading || c.listBusy}
          >
            Today
          </button>
          <button
            type="button"
            className={ghostBtnClass}
            onClick={() => c.shiftWeek(1)}
            disabled={!gate.enabled || gate.loading || c.listBusy}
          >
            Next week →
          </button>
          <button
            type="button"
            className={ghostBtnClass}
            onClick={handleRefresh}
            disabled={gate.loading || c.listBusy}
          >
            {c.listBusy ? "Refreshing…" : "Refresh"}
          </button>
        </div>
      </div>

      <LogisticsGateBanner gate={gate} />
      {gate.enabled && c.localError ? (
        <div className="rounded-2xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-900 dark:border-red-800 dark:bg-red-950/35 dark:text-red-100">
          {c.localError}
        </div>
      ) : null}

      {gate.enabled ? (
        <>
          <div className="text-sm text-gray-600 dark:text-zinc-400">Week of {c.weekLabel}</div>
          <LogisticsCalendarWeekGrid
            weekKeys={c.weekKeys}
            rollups={c.weekRollups}
            selectedDay={c.selectedDay}
            onSelectDay={c.selectDay}
          />
          <LogisticsCalendarDayRoutes
            rollup={c.selectedDayRollup}
            units={c.units}
            carriers={c.carriers}
            selectedRouteId={c.selectedRouteId}
            onSelectRoute={c.selectRoute}
          />
          {c.selectedRouteId ? (
            <LogisticsRoutesDetailCard
              listModel={labelLookup}
              routeId={c.selectedRouteId}
              detailNavTick={c.detailNavTick}
              onAfterStateChange={c.handleAfterStateChange}
              onClose={() => c.selectRoute(c.selectedRouteId!)}
            />
          ) : null}
        </>
      ) : null}
    </div>
  );
}
